import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MultiSelectComponent } from '../multi-select/multi-select.component';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { SEMANAS } from '../../constants/semanas';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';

@Component({
  selector: 'sgt-semana-multi-select',
  templateUrl: './semana-multi-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SemanaMultiSelectComponent),
      multi: true,
    },
  ],
})
export class SemanaMultiSelectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() semanas: number[] | null = null;
  @Output() changed = new EventEmitter<number[] | null>();

  @ViewChild('multiSelectRef')
  multiSelectComponent: MultiSelectComponent;

  @Input() settings: IMultiSelectSettings;

  defaultSettings: IMultiSelectSettings = {
    placeholder: 'Semanas',
    singular: 'Semana',
    plural: 'Semanas',
    isDisabled: false,
  };

  semanasSelectOptions: IOption[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.buildSelectOptions();

    this.settings = {
      ...this.defaultSettings,
      ...this.settings,
    };
  }

  buildSelectOptions() {
    SEMANAS.forEach((semana) => {
      this.semanasSelectOptions.push({
        id: semana.id,
        label: semana.nome,
      });
    });
  }

  updateComponent(value: number[]): void {
    this.updateValue(value);
  }

  // Disparado quando o usuário altera a seleção manualmente
  onSelectionChange(): void {
    const selected = this.semanasSelectOptions
      .filter((opt) => opt.isChecked)
      .map((opt) => opt.id);

    this.emitChange(selected);
    this.changed.emit(selected);
    this.markAsTouched();
  }

  // Implementação do método abstrato da classe base
  protected updateValue(value: number[] | null): void {
    const selectedId = value;

    this.updateCheckedSemanasInternal(selectedId);
  }

  // Override do onDisabledStateChange para atualizar as configurações
  protected onDisabledStateChange(isDisabled: boolean): void {
    this.settings = {
      ...this.settings,
      isDisabled,
    };
  }

  // Atualiza o estado checked com base nos IDs selecionados
  private updateCheckedSemanasInternal(selectedIds: number[]): void {
    this.semanasSelectOptions.forEach((option) => {
      option.isChecked = selectedIds.includes(option.id);
    });

    this.syncMultiSelectSemanas();
  }

  // Sincroniza manualmente com o componente filho
  private syncMultiSelectSemanas(): void {
    if (!this.multiSelectComponent) {
      return;
    }

    this.multiSelectComponent.options = [...this.semanasSelectOptions];
    this.multiSelectComponent.filteredOptions = [...this.semanasSelectOptions];
    this.multiSelectComponent.totalSelectedOptions();
    this.multiSelectComponent.changePlaceholder();
  }

  setSelection(selectedIds: number[]): void {
    this.updateComponent(selectedIds);
  }

  clearSelection(): void {
    this.value = [];
    this.updateCheckedSemanasInternal([]);
    this.changed.emit([]);
  }
}
